import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NavbarModule } from '@components/navbar/navbar.module';
import { PageModule } from '@components/page/page.module';
import { authInterceptor } from '@interceptors/auth.interceptor';
import { errorInterceptor } from '@interceptors/errors.interceptor';
import { PermissionsService } from '@services/permissions.service';
import { NgxPermissionsModule, NgxPermissionsService } from 'ngx-permissions';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { apiRouteProviderInterceptor } from './shared/interceptors/api-route.interceptor';
import { ConfirmModalModule } from '@components/confirm-modal/confirm-modal.module';
import { NgSelectModule } from '@ng-select/ng-select';
@NgModule({
  declarations: [AppComponent],
  imports: [
    NgSelectModule,
    MatSlideToggleModule,
    CommonModule,
    NgxPermissionsModule.forRoot(),
    BrowserModule,
    AppRoutingModule,
    NavbarModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatProgressBarModule,
    PageModule,
    MatDialogModule,
    ConfirmModalModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (ds: PermissionsService) => { return ( async () => {
        return await ds.loadPermission();
      })},
      deps: [PermissionsService, NgxPermissionsService, HttpClient],
      multi: true,
    },
    apiRouteProviderInterceptor,
    errorInterceptor,
    authInterceptor,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
